export const DEFAULT_POSITION = { x: 24, y: 24 };

export const DRAG_MOVE_THRESHOLD = 6;

export const INITIAL_MESSAGES = [
	{
		id: 'greeting',
		role: 'assistant',
		text: "Hi! I'm Buddy, your operations assistant. Ask me about drivers, rides, routes, or crew.",
		card: null,
	},
];
